var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconExclamationTriangle = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-0.567 -2.055)" },
                React.createElement("path", { d: "M13.7,8.3L4.5,23.6c-0.6,1-0.2,2.4,0.8,3c0.3,0.2,0.7,0.3,1.1,0.3h18.4c1.2,0,2.2-1,2.1-2.2\n\t\tc0-0.4-0.1-0.7-0.3-1.1L17.4,8.3c-0.6-1-2-1.3-3-0.7C14.1,7.7,13.9,8,13.7,8.3L13.7,8.3z" }),
                React.createElement("path", { d: "M15.6,13.9v4.3" }),
                React.createElement("path", { d: "M15.6,22.5L15.6,22.5" })))));
});
export default IconExclamationTriangle;
//# sourceMappingURL=IconExclamationTriangle.js.map